import { render, staticRenderFns } from "./SelectItems.vue?vue&type=template&id=36f3f0bf&scoped=true&"
import script from "./SelectItems.vue?vue&type=script&lang=js&"
export * from "./SelectItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3f0bf",
  null
  
)

export default component.exports